<template>
  <div class="Program-view-page w-100">
    <b-overlay
      :show="loading"
      rounded
      opacity="0.8"
      spinner-variant="success"
      spinner-type="border"
      spinner-size="lg"
    >
      <basic-subheader>
        <template v-slot:actions>
          <div class="header-buttons-container">
            <b-button
              v-if="viewMode === 'week' && isInsertPermission"
              class="btn btn-success"
              type="button"
              @click="showAddProgramModal"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
              </span>
              Thêm chương trình
            </b-button>

            <div class="navigation-buttons">
              <b-button class="btn ml-3" type="button" @click="returnPage">
                <span class="svg-icon">
                  <inline-svg
                    src="/media/svg/icons/Neolex/Arrows/arrow-left.svg"
                  />
                </span>
                Trở về trước
              </b-button>
              <b-button
                class="btn ml-3 custom-btn"
                type="button"
                @click="toggleViewMode"
              >
                <span class="toggle-container">
                  <span
                    class="toggle-text"
                    :class="{ active: viewMode !== 'week' }"
                    >Theo ngày</span
                  >
                  |
                  <span
                    class="toggle-text"
                    :class="{ active: viewMode === 'week' }"
                    >Theo tuần</span
                  >
                </span>
              </b-button>
            </div>
          </div>
        </template>
      </basic-subheader>
      <!-- Schedule of Program (included Programs)-->
      <component
        :is="viewMode === 'week' ? 'ScheduleProgramWeek' : 'ScheduleProgramDay'"
        ref="scheduleProgram"
        @edit-program="editProgram"
        :servicePackageData="servicePackageData"
        :servicePackageId="servicePackageId"
        @delete-program="handleDeleteProgram"
        :numberOfWeeks="numberOfWeeks"
      />

      <!-- Modal Thêm/Sửa Program -->
      <b-modal
        id="program-modal"
        ref="programModal"
        :title="isEditing ? 'Cập nhật Program' : 'Thêm program'"
        size="lg"
        hide-footer
        @hidden="resetProgramForm"
      >
        <div class="form-container">
          <div class="form-row d-flex">
            <div class="form-row w-100">
              <div class="form-group" style="flex: 9">
                <label>
                  Tên program hoặc mã program
                  <span style="color: red">*</span>
                </label>
                <basic-select
                  placeholder="Loại bài học"
                  name="type"
                  :solid="false"
                  changeValueByObject
                  trackBy="value"
                  valueLabel="text"
                  :options="programs"
                  :value.sync="selectedProgram"
                />
              </div>
              <div class="form-group" style="flex: 3">
                <label>Tuần bắt đầu</label>
                <select v-model="programForm.startWeek" class="form-input">
                  <option
                    v-for="week in numberOfWeeks"
                    :key="week"
                    :value="week"
                  >
                    Tuần {{ week }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-actions mt-4">
            <b-button
              variant="success"
              @click="handleSubmitProgram"
              class="mr-2"
            >
              {{ isEditing ? 'Cập nhật' : 'Thêm program' }}
            </b-button>
            <b-button variant="secondary" @click="hideModal"> Hủy </b-button>
          </div>
        </div>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import ScheduleProgramWeek from './components/ScheduleServicePackageWeek.vue';
import ScheduleProgramDay from './components/ScheduleServicePackageDay.vue';

export default {
  components: {
    ScheduleProgramWeek,
    ScheduleProgramDay,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      selectedProgram: '',
      programs: [],
      servicePackageData: {},
      viewMode: 'week', // 'week' hoặc 'day'
      programForm: this.getDefaultProgramForm(),
      isEditing: false,
      editingId: null,
      numberOfWeeks: 10, // Số tuần mặc định
    };
  },
  computed: {
    servicePackageId() {
      return this.id || this.$route.params.id;
    },
    scheduleProgram() {
      return this.$refs.scheduleProgram;
    },
  },
  methods: {
    // Các phương thức điều hướng
    returnPage() {
      this.$router.push({ name: 'service_package_list' });
    },
    toggleViewMode() {
      this.viewMode = this.viewMode === 'week' ? 'day' : 'week';
    },

    // Các phương thức tiện ích
    getDefaultProgramForm() {
      return {
        startWeek: 1,
        duration: 1,
        type: '',
        color: '#16A45A',
        programServicePackageMappingId: '',
      };
    },

    updatePrograms(programs) {
      this.programs = programs;
    },
    getStartDay(startWeek) {
      // Ngày bắt đầu của tuần là (startWeek - 1) * 7 + 1
      // Ví dụ: Tuần 1 bắt đầu từ ngày 1, tuần 2 bắt đầu từ ngày 8
      return (startWeek - 1) * 7 + 1;
    },

    // Xử lý modal
    showAddProgramModal() {
      this.resetProgramForm();
      this.$refs.programModal.show();
    },
    hideModal() {
      this.$refs.programModal.hide();
    },
    resetProgramForm() {
      this.programForm = this.getDefaultProgramForm();
      this.selectedProgram = '';
      this.isEditing = false;
      this.editingId = null;
    },
    editProgram(program) {
      this.isEditing = true;
      this.editingId = program.id;
      this.programForm = { ...this.getDefaultProgramForm(), ...program };
      this.selectedProgram =
        this.programs.find(
          (m) => m.value === program.id || m.value === program.type,
        ) || '';
      this.$refs.programModal.show();
    },

    // Xác thực form
    validateProgramForm() {
      if (!this.selectedProgram) {
        this.$swal('Lỗi!', 'Vui lòng chọn program', 'error');
        return false;
      }

      const maxWeek =
        this.programForm.startWeek + this.selectedProgram.totalWeek;

      if (maxWeek > this.numberOfWeeks + 1) {
        return new Promise((resolve) => {
          this.$swal({
            title: 'Cảnh báo!',
            text: `Program này kéo dài đến tuần ${
              maxWeek - 1
            }, vượt quá số tuần hiện tại ${
              this.numberOfWeeks
            }. Bạn có muốn mở rộng thêm số tuần không?`,
            icon: 'warning',
            buttons: {
              cancel: {
                text: 'Không, tôi sẽ điều chỉnh lại',
                value: false,
                visible: true,
                className: 'btn btn-secondary',
                closeModal: true,
              },
              confirm: {
                text: 'Có, mở rộng số tuần',
                value: true,
                visible: true,
                className: 'btn btn-primary',
                closeModal: true,
              },
            },
          }).then((result) => {
            if (result) {
              this.updateNumberOfWeeks(maxWeek - 1);
              resolve(true);
            } else {
              resolve(false);
            }
          });
        });
      }
      return true;
    },
    updateNumberOfWeeks(newWeeks) {
      this.numberOfWeeks = newWeeks;
      // Cập nhật numberOfWeeks cho Program (nếu cần)
      if (this.servicePackageId) {
        this.updateProgramNumberOfWeeks(this.numberOfWeeks).catch((error) => {
          console.error('Lỗi khi cập nhật số tuần cho program:', error);
          this.$swal(
            'Cảnh báo',
            'Số tuần đã được cập nhật trên giao diện nhưng chưa được lưu vào cơ sở dữ liệu. Vui lòng thử lại hoặc làm mới trang.',
            'warning',
          );
        });
      }
    },
    // Thêm phương thức mới để cập nhật totalWeek của Program
    async updateProgramNumberOfWeeks(numberOfWeeks) {
      try {
        const formData = new FormData();
        formData.append('totalWeek', numberOfWeeks);
        // Gọi API để cập nhật totalWeek của Program
        await this.$api.put(
          `ServicePackage/${this.servicePackageId}`,
          formData,
        );
      } catch (error) {
        console.error('Lỗi khi cập nhật số tuần:', error);
        throw error;
      }
    },
    // Xử lý submit/update program
    async handleSubmitProgram() {
      const validationResult = this.validateProgramForm();

      // Xử lý trường hợp validateProgramForm trả về Promise
      if (validationResult instanceof Promise) {
        const isValid = await validationResult;
        if (!isValid) return;
      } else if (!validationResult) {
        return;
      }

      // Chuẩn bị dữ liệu program
      const programTitle =
        this.programs.find((m) => m.value === this.selectedProgram.value)
          ?.text || '';

      const programData = {
        ...this.programForm,
        title: programTitle,
        type: this.selectedProgram.value,
        id: this.editingId || '',
        duration: this.selectedProgram.totalWeek || 1,
        color: this.selectedProgram.color, // Add this line to use the program's color
      };

      try {
        // this.loading = true;

        if (this.isEditing) {
          this.updateExistingServicePackage(programData);
        } else {
          this.createNewProgram(programData);
        }

        this.hideModal();
        this.$swal(
          'Thành công!',
          `Đã ${this.isEditing ? 'cập nhật' : 'thêm'} program thành công`,
          'success',
        );
      } catch (error) {
        this.$swal('Lỗi!', error.message || 'Đã có lỗi xảy ra', 'error');
      } finally {
        // this.loading = false;
      }
    },
    updateProgramMappingId(programType, mappingId) {
      if (this.scheduleProgram && this.scheduleProgram.events) {
        // Tìm program với type tương ứng
        const index = this.scheduleProgram.events.findIndex(
          (e) => e.type === programType,
        );

        if (index !== -1) {
          // Tạo bản sao để kích hoạt reactivity
          let events = [...this.scheduleProgram.events];
          events[index].programServicePackageMappingId = mappingId;
          this.scheduleProgram.events = events;
        }
      }
    },
    getStartWeek(startAtDay) {
      // Nếu startAtDay là null, undefined hoặc 0, mặc định là tuần 1
      if (!startAtDay) return 1;

      // Tính tuần bằng cách chia (startAtDay - 1) cho 7 và cộng thêm 1
      // Điều này đảm bảo ngày 1-7 thuộc tuần 1, ngày 8-14 thuộc tuần 2, v.v.
      return Math.floor((startAtDay - 1) / 7) + 1;
    },
    async createNewProgram(programData) {
      // Generate a temporary ID for immediate UI update
      const tempId = `temp-${Date.now()}`;

      // Create a copy of programData with the temporary ID
      const tempProgramData = {
        ...programData,
        programServicePackageMappingId: tempId,
      };

      // Update UI immediately
      this.scheduleProgram.addProgram(tempProgramData);

      // Add to servicePackageData for cross-view persistence
      const tempProgramForProgram = {
        id: programData.id,
        name: programData.title,
        startAtDay: this.getStartDay(programData.startWeek),
        totalWeek: programData.duration,
        type: programData.type,
        color: programData.color,
        programServicePackageMappingId: tempId,
      };

      this.servicePackageData = {
        ...this.servicePackageData,
        programs: [
          ...(this.servicePackageData.programs || []),
          tempProgramForProgram,
        ],
      };

      try {
        // Call API in the background
        const mappingId = await this.createProgramProgramMappings(
          programData.type,
          this.getStartDay(programData.startWeek),
        );

        // Update the real ID in the component and servicePackageData
        if (this.scheduleProgram && this.scheduleProgram.events) {
          this.scheduleProgram.events = this.scheduleProgram.events.map(
            (event) => {
              if (event.programServicePackageMappingId === tempId) {
                return { ...event, programServicePackageMappingId: mappingId };
              }
              return event;
            },
          );
        }

        if (this.servicePackageData && this.servicePackageData.programs) {
          this.servicePackageData.programs =
            this.servicePackageData.programs.map((program) => {
              if (program.programServicePackageMappingId === tempId) {
                return {
                  ...program,
                  programServicePackageMappingId: mappingId,
                };
              }
              return program;
            });
        }
      } catch (error) {
        // Handle error - revert UI changes
        console.error('Error creating program:', error);

        // Remove the temporary program from UI
        if (this.scheduleProgram && this.scheduleProgram.events) {
          this.scheduleProgram.events = this.scheduleProgram.events.filter(
            (event) => event.programServicePackageMappingId !== tempId,
          );
        }

        if (this.servicePackageData && this.servicePackageData.programs) {
          this.servicePackageData.programs =
            this.servicePackageData.programs.filter(
              (program) => program.programServicePackageMappingId !== tempId,
            );
        }

        this.$swal(
          'Lỗi!',
          'Đã có lỗi khi tạo program, vui lòng thử lại.',
          'error',
        );
      }
    },

    async updateExistingServicePackage(programData) {
      // Store original data for rollback if needed
      let originalProgram = null;

      if (this.servicePackageData && this.servicePackageData.programs) {
        originalProgram = this.servicePackageData.programs.find(
          (m) =>
            m.programServicePackageMappingId ===
            programData.programServicePackageMappingId,
        );
      }

      // Update UI immediately
      this.scheduleProgram.updateProgram(programData);

      // Update servicePackageData for cross-view persistence
      if (this.servicePackageData && this.servicePackageData.programs) {
        const programIndex = this.servicePackageData.programs.findIndex(
          (m) =>
            m.programServicePackageMappingId ===
            programData.programServicePackageMappingId,
        );

        if (programIndex !== -1) {
          const updatedPrograms = [...this.servicePackageData.programs];
          updatedPrograms[programIndex] = {
            id: programData.id,
            name: programData.title,
            startAtDay: this.getStartDay(programData.startWeek),
            totalWeek: programData.duration,
            type: programData.type,
            color: programData.color,
            programServicePackageMappingId:
              programData.programServicePackageMappingId,
          };

          this.servicePackageData = {
            ...this.servicePackageData,
            programs: updatedPrograms,
          };
        }
      }

      try {
        // Call API in the background
        const data = {
          ProgramId: programData.type,
          ServicePackageId: this.servicePackageId,
          startAtDay: this.getStartDay(programData.startWeek),
        };

        await this.editServicePackageProgramMappings(
          programData.programServicePackageMappingId,
          data,
        );
      } catch (error) {
        console.error('Error updating program:', error);

        // Roll back UI changes if API call fails
        if (
          originalProgram &&
          this.servicePackageData &&
          this.servicePackageData.programs
        ) {
          const programIndex = this.servicePackageData.programs.findIndex(
            (m) =>
              m.programServicePackageMappingId ===
              programData.programServicePackageMappingId,
          );

          if (programIndex !== -1) {
            const updatedPrograms = [...this.servicePackageData.programs];
            updatedPrograms[programIndex] = originalProgram;

            this.servicePackageData = {
              ...this.servicePackageData,
              programs: updatedPrograms,
            };
          }

          // Update UI back to original
          if (this.scheduleProgram) {
            const originalUIProgram = {
              id: originalProgram.id,
              title: originalProgram.name,
              startWeek: this.getStartWeek(originalProgram.startAtDay),
              duration: originalProgram.totalWeek,
              type: originalProgram.type,
              color: originalProgram.color,
              programServicePackageMappingId:
                originalProgram.programServicePackageMappingId,
            };

            this.scheduleProgram.updateProgram(originalUIProgram);
          }
        }

        this.$swal(
          'Lỗi!',
          'Đã có lỗi khi cập nhật program, vui lòng thử lại.',
          'error',
        );
      }
    },

    async handleDeleteProgram(programServicePackageMappingId) {
      // Store deleted program for potential rollback
      let deletedProgram = null;
      let deletedUIProgram = null;

      if (this.servicePackageData && this.servicePackageData.programs) {
        deletedProgram = this.servicePackageData.programs.find(
          (program) =>
            program.programServicePackageMappingId ===
            programServicePackageMappingId,
        );
      }

      if (this.scheduleProgram && this.scheduleProgram.events) {
        deletedUIProgram = this.scheduleProgram.events.find(
          (event) =>
            event.programServicePackageMappingId ===
            programServicePackageMappingId,
        );

        // Update UI immediately
        this.scheduleProgram.events = this.scheduleProgram.events.filter(
          (event) =>
            event.programServicePackageMappingId !==
            programServicePackageMappingId,
        );
      }

      // Update servicePackageData for cross-view persistence
      if (this.servicePackageData && this.servicePackageData.programs) {
        this.servicePackageData.programs =
          this.servicePackageData.programs.filter(
            (program) =>
              program.programServicePackageMappingId !==
              programServicePackageMappingId,
          );
      }

      try {
        this.$swal('Thành công!', 'Đã xóa program thành công', 'success');
        // Call API in the background
        this.$api.delete(
          `ServicePackageProgram/${programServicePackageMappingId}`,
        );

        // Show success message
      } catch (error) {
        console.error('Error deleting program:', error);

        // Roll back UI changes if API call fails
        if (deletedProgram && this.servicePackageData) {
          this.servicePackageData.programs = [
            ...this.servicePackageData.programs,
            deletedProgram,
          ];
        }

        if (deletedUIProgram && this.scheduleProgram) {
          this.scheduleProgram.events = [
            ...this.scheduleProgram.events,
            deletedUIProgram,
          ];
        }

        this.$swal(
          'Lỗi!',
          'Đã có lỗi khi xóa program, vui lòng thử lại.',
          'error',
        );
      }
    },
    // API requests
    async loadServicePackageData() {
      if (!this.servicePackageId) return;

      try {
        const { data } = await this.$api.get(
          `ServicePackage/${this.servicePackageId}`,
        );
        this.servicePackageData = data;
        this.numberOfWeeks = data.totalWeek || this.numberOfWeeks;
        return data; // Return data for Promise.all to handle
      } catch (error) {
        console.error('Error loading program data:', error);
        throw error; // Throw error so Promise.all can catch it
      }
    },

    async loadProgramsData() {
      try {
        const { data } = await this.$api.get(`Program/All`);
        this.programs = data.map((item) => ({
          text: item?.name,
          totalWeek: item?.totalWeek,
          value: item?.id,
          color: item.color,
        }));
        return data; // Return data for Promise.all to handle
      } catch (error) {
        console.error('Error loading programs data:', error);
        throw error; // Throw error so Promise.all can catch it
      }
    },
    async createProgramProgramMappings(programProgramId, startAtDay) {
      if (!this.servicePackageId)
        throw new Error('Không tìm thấy ID chương trình');

      const formData = new FormData();
      formData.append('ServicePackageId', this.servicePackageId);
      formData.append('ProgramId', programProgramId);
      formData.append('startAtDay', startAtDay);

      // Gửi API request
      const { data } = await this.$api.post(`ServicePackageProgram`, formData);
      return data;
    },

    async editServicePackageProgramMappings(id, data) {
      return await this.$api.put(`ServicePackageProgram/${id}`, data);
    },

    async inactiveItem(item) {
      const payload = new FormData();
      payload.append('id', item.id);
      payload.append('active', !item.isActive);
      return await this.$api.put(`Program`, payload);
    },

    handleInactive(item) {
      const text = item.isActive ? 'Inactive' : 'Active';
      const btn = item.isActive ? 'btn-inactive' : 'btn-active';

      this.$swal({
        title: '',
        text: `Bạn có chắc muốn ${text} app user ${item.id} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `${text}`,
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then((result) => {
        if (result) {
          this.inactiveItem(item)
            .then(() => {
              this.loadServicePackageData();
              this.$swal(
                'Thành công!',
                'Chúc mừng, bạn đã cập nhật thông tin Program thành công!',
                'success',
              );
            })
            .catch(() => {
              this.$swal('Lỗi!', 'Đã có lỗi xảy ra.', 'error');
            });
        }
      });
    },
  },
  mounted() {
    this.loading = true; // Set loading to true before starting API calls

    // Use Promise.all to wait for both API calls to complete
    Promise.all([this.loadServicePackageData(), this.loadProgramsData()])
      .then(() => {
        console.log('All data loaded successfully');
      })
      .catch((error) => {
        console.error('Error loading data:', error);
        this.$swal(
          'Lỗi!',
          'Đã có lỗi khi tải dữ liệu, vui lòng thử lại.',
          'error',
        );
      })
      .finally(() => {
        this.loading = false; // Set loading to false after all API calls are done
      });
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: 600;
}

.header-buttons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.navigation-buttons {
  display: flex;
  align-items: center;
}

.form-container {
  padding: 10px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.form-group {
  flex: 1;
  min-width: 200px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
}

.custom-btn {
  border: 1px solid #008479 !important;
  color: #008479 !important;
  background-color: transparent;
}

.toggle-text.active {
  font-weight: bold;
}
::v-deep .b-overlay .spinner-border {
  width: 4rem !important;
  height: 4rem !important;
  border-width: 0.3em !important;
}
::v-deep .b-overlay {
  min-height: 100vh;
}
::v-deep .b-overlay > .position-absolute {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
